import * as AppearanceGlobalAssetsActions from '../store/actions/appearanceGlobalAssetsActions';
import { storeStructure } from '../store/reducers';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  actionCreate: AppearanceGlobalAssetsActions.createAppearanceGlobalAssets,
  actionUpdate: AppearanceGlobalAssetsActions.updateAppearanceGlobalAssets,
  actionGetDraftId: AppearanceGlobalAssetsActions.getDraftId,
  storeNode: storeStructure.AppearanceGlobalAssets,
  title: 'Whitelabel web',
  fields: [
    {
      attributeName: 'logoIdWhitelabel',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Logo',
      helpText: 'Logo image above the main panel.',
      fileType: ['image/*'],
    },
    // {
    //   attributeName: 'sloganIdWhitelabel',
    //   type: FormInputTypes.DOWNLOADABLE,
    //   label: 'Slogan',
    //   helpText: 'Slogan image above the main panel.',
    // },
    {
      attributeName: 'faviconId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Favicon',
      helpText: 'Favicon image for the tab.',
      fileType: ['image/*'],
    },
    {
      attributeName: 'backgroundColor',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Background Color',
      helpText: 'Background color of the site',
    },
    {
      attributeName: 'primaryColor',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Primary Color',
      helpText: 'Primary color used for the site',
    },
    {
      attributeName: 'secondaryColor',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Text Color',
      helpText: 'Color of the text for the whole site',
    },
    {
      attributeName: 'accentColor',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Accent Color',
      helpText: 'Color of the accents for the whole site',
    },
    {
      attributeName: 'iconColor',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Icon Color',
      helpText: 'Color of the icons for the whole site',
    },
  ],
};
